import React from "react";
import Input from "../../util/Input";
import { PropTypes } from "prop-types";

const DomainBlockInfo = props => {

  return (
    <div className="AppSection">
 
       <div className="leftColumn margin-height">
            <Input
              labelText={"Domain"}
              className={"margin-height lblNVGreen required"}
              inputClassName={"margin-left2"}
              isRequired={true}
              autoFocus={props.autoFocusName}
              value={props.orgData.Domain}
              onChange={props.handleDomainChange}
           />

            <div className="flex-fill margin-height">
                 <center><button className="btn" onClick={props.onSaveClick} disabled={!props.dataFilled} > Save  </button> </center>
            </div>
        </div>
    </div>
  );
};

DomainBlockInfo.propTypes = {
  isRequired: PropTypes.bool,
  autoFocusName: PropTypes.bool,
  orgData: PropTypes.object,
  handleDomainChange: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func,
  dataFilled: PropTypes.bool
};

export default DomainBlockInfo;

